import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router';

interface CreativeMediaProps {
  planId: string;
  onSubmitAndRedirect?: () => void;
}

const CreativeMedia: React.FC<CreativeMediaProps> = ({ planId, onSubmitAndRedirect }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onSubmitAndRedirect) {
      onSubmitAndRedirect();
    }

    navigate(`/admin/plan/creative-studio/${planId}`);
  };

  return (
    <Button type="primary" onClick={handleClick}>
      Creative Studio
    </Button>
  );
};

export default CreativeMedia;
